import { SelectOption } from 'components/inputs/select';
import { IndexDef, VectorField } from 'types/fts';

export const defaultIndexDef: IndexDef = {
  name: '',
  type: 'fulltext-index',
  sourceType: 'couchbase',
  sourceName: '',
  sourceUUID: '',
  params: {
    mapping: {
      types: {},
      default_mapping: {
        enabled: false,
        dynamic: false,
      },
      default_type: '_default',
      default_analyzer: 'standard',
      default_datetime_parser: 'dateTimeOptional',
      default_field: '_all',
      store_dynamic: true,
      index_dynamic: true,
      docvalues_dynamic: false,
    },
    store: {
      indexType: 'scorch',
      kvStoreName: '',
    },
    doc_config: {
      mode: 'scope.collection.type_field',
      type_field: 'type',
      docid_prefix_delim: '',
      docid_regexp: '',
    },
  },
  sourceParams: {},
  planParams: {
    maxPartitionsPerPIndex: 64,
    numReplicas: 0,
    indexPartitions: 1,
  },
  uuid: '',
  id: '',
};

export const similarityOptions: SelectOption<VectorField['similarity']>[] = [
  { value: 'l2_norm', label: 'l2_norm' },
  { value: 'dot_product', label: 'dot_product' },
  { value: 'cosine', label: 'cosine' },
];
export const optimizedForOptions: SelectOption<VectorField['vector_index_optimized_for']>[] = [
  { value: 'recall', label: 'recall' },
  { value: 'latency', label: 'latency' },
  { value: 'memory-efficient', label: 'memory-efficient' },
];

export const VECTOR_BASE64 = 'vector_base64';
export const VECTOR = 'vector';
